import React, { useState } from 'react';
import {
    FaShieldAlt,
    FaLock,
    FaUserShield,
    FaDatabase,
    FaClock,
    FaCheckCircle,
    FaFileDownload,
    FaEnvelope,
    FaPhone,
    FaMapMarkerAlt,
    FaBook
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Confidentialite = () => {
    const [showCatalog, setShowCatalog] = useState(false);

    return (
        <>
            <Header />
            <div className="policy-wrapper">
                

                {/* Modal Catalogue */}
                {showCatalog && (
                    <div className="catalog-modal" onClick={() => setShowCatalog(false)}>
                        <div className="catalog-content" onClick={e => e.stopPropagation()}>
                            <button className="close-btn" onClick={() => setShowCatalog(false)}>×</button>
                            <div className="catalog-header">
                                <FaBook className="catalog-icon" />
                                <h3>Catalogue de Formations 2025</h3>
                            </div>
                            <p className="catalog-description">
                                Découvrez notre catalogue complet avec plus de 100 formations professionnelles
                                dans 11 domaines d'expertise.
                            </p>
                            <div className="catalog-actions">
                                <a
                                    href="https://www.cinef-bj.com/formations/docs/catalogue_cinef_2026.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="download-btn"
                                >
                                    <FaFileDownload />
                                    Télécharger le catalogue
                                </a>
                                <button className="view-btn">
                                    Consulter en ligne
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Hero simple et élégant */}
                <section className="hero-section">
                    <div className="container-policy">

                        <h1 className="hero-title">Politique de Confidentialité</h1>
                        <p className="hero-desc">
                            CINEF s'engage à protéger la confidentialité de vos données personnelles.
                            Cette politique explique comment nous collectons, utilisons et protégeons vos informations
                            conformément aux lois n° 2017-20 et n°2009-09 en vigueur en République du Bénin.
                        </p>
                        <div className="hero-meta">
                            <span><FaClock /> Dernière mise à jour : Janvier 2026</span>
                        </div>

                        <button
                            className="catalog-btn"
                            onClick={() => setShowCatalog(!showCatalog)}
                        >
                            <FaBook />
                            <span>Catalogue</span>
                        </button>
                    </div>
                </section>

                {/* Contenu principal */}
                <section className="main-content">
                    <div className="container-policy">

                        {/* Introduction */}
                        <div className="content-block">
                            <h2 className="section-title">À propos de ce document</h2>
                            <div className="text-content">
                                <p>
                                    Ce document présente la politique en vigueur sur le site <strong>www.cinef-bj.com</strong> (le "Site")
                                    édité par la société CINEF SAS, en matière de vie privée et de protection des données à caractère
                                    personnel (ci-après la "Politique"). Conformément aux lois n° 2017-20 portant code du numérique en
                                    République du Bénin et n°2009-09 du 22 mai 2009 portant protection des données à caractère personnel
                                    en République du Bénin, le site www.cinef-bj.com a fait l'objet d'une déclaration auprès de l'Autorité
                                    de Protection des Données à caractère Personnel.
                                </p>
                            </div>
                        </div>

                        {/* Collecte des données */}
                        <div className="content-block">
                            <div className="title-with-icon">
                                <FaDatabase className="section-icon" />
                                <h2 className="section-title">Collecte des données personnelles</h2>
                            </div>
                            <div className="text-content">
                                <p>
                                    CINEF collecte des données personnelles dans le cadre de ses activités de formation professionnelle
                                    et de conseil. Les informations collectées peuvent inclure votre nom, prénom, adresse email, numéro
                                    de téléphone, entreprise d'appartenance, fonction, ainsi que toute autre information nécessaire à la
                                    fourniture de nos services.
                                </p>
                                <p>
                                    Ces données sont collectées directement auprès de vous lors de votre inscription à nos formations,
                                    lors de l'utilisation de nos services en ligne, ou via nos formulaires de contact. Nous pouvons
                                    également collecter des informations techniques telles que votre adresse IP, le type de navigateur
                                    utilisé, et les pages consultées sur notre site à des fins d'amélioration de nos services.
                                </p>
                                <p>
                                    Dans certains cas spécifiques liés aux formations, nous pouvons être amenés à collecter des données
                                    concernant d'éventuelles allergies alimentaires ou des situations de handicap, uniquement avec votre
                                    consentement explicite et dans le but de vous fournir un environnement de formation adapté.
                                </p>
                            </div>
                        </div>

                        {/* Utilisation des données */}
                        <div className="content-block">
                            <div className="title-with-icon">
                                <FaUserShield className="section-icon" />
                                <h2 className="section-title">Utilisation des données</h2>
                            </div>
                            <div className="text-content">
                                <p>
                                    Les données personnelles collectées sont utilisées aux fins suivantes :
                                </p>
                                <ul className="styled-list">
                                    <li>Gestion de vos inscriptions aux formations et suivi de votre parcours pédagogique</li>
                                    <li>Communication concernant nos formations, événements et actualités</li>
                                    <li>Traitement de vos demandes de renseignements et support client</li>
                                    <li>Amélioration de nos services et de l'expérience utilisateur sur notre site</li>
                                    <li>Établissement de statistiques et analyses de fréquentation</li>
                                    <li>Respect de nos obligations légales et réglementaires</li>
                                </ul>
                                <p>
                                    CINEF s'engage à ne pas utiliser vos données à d'autres fins que celles mentionnées ci-dessus sans
                                    votre consentement préalable. Nous ne vendons ni ne louons vos informations personnelles à des tiers
                                    à des fins commerciales.
                                </p>
                            </div>
                        </div>

                        {/* Conservation des données */}
                        <div className="content-block">
                            <div className="title-with-icon">
                                <FaClock className="section-icon" />
                                <h2 className="section-title">Durée de conservation</h2>
                            </div>
                            <div className="text-content">
                                <p>
                                    Les données personnelles sont conservées pour la durée nécessaire à la réalisation des finalités
                                    pour lesquelles elles ont été collectées. Les données collectées dans le cadre de la gestion de
                                    vos formations sont conservées pendant toute la durée de votre relation avec CINEF, puis archivées
                                    conformément aux obligations légales en matière de conservation des documents comptables et fiscaux.
                                </p>
                                <p>
                                    Les données collectées à des fins de prospection commerciale sont conservées pendant une durée
                                    maximale de cinq (05) ans à compter de la fin de la relation commerciale. Les données concernant
                                    d'éventuelles allergies alimentaires ou des situations de handicap ne sont conservées que pour la
                                    durée de l'action de formation concernée.
                                </p>
                                <p>
                                    À l'issue de ces périodes, vos données sont supprimées de manière sécurisée ou anonymisées de
                                    façon irréversible, sauf obligation légale contraire nous imposant de les conserver plus longtemps.
                                </p>
                            </div>
                        </div>

                        {/* Sécurité */}
                        <div className="content-block">
                            <div className="title-with-icon">
                                <FaLock className="section-icon" />
                                <h2 className="section-title">Sécurité des données</h2>
                            </div>
                            <div className="text-content">
                                <p>
                                    CINEF prend des mesures techniques et organisationnelles appropriées pour interdire l'accès non
                                    autorisé ou la divulgation de vos données personnelles. Ces mesures comprennent :
                                </p>
                                <ul className="styled-list">
                                    <li>Sécurisation de l'accès à nos locaux et à nos plateformes informatiques</li>
                                    <li>Chiffrement des données sensibles lors de leur transmission et stockage</li>
                                    <li>Contrôle d'accès strict limité aux collaborateurs autorisés</li>
                                    <li>Sensibilisation régulière de nos équipes aux exigences de confidentialité</li>
                                    <li>Audits de sécurité réguliers de nos systèmes d'information</li>
                                    <li>Plans de continuité d'activité et de récupération des données en cas d'incident</li>
                                </ul>
                                <p>
                                    Un responsable de la protection des données est désigné au sein de CINEF pour superviser la mise
                                    en œuvre de ces mesures et garantir leur efficacité continue. Malgré ces précautions, aucun système
                                    de transmission de données sur Internet ou de stockage électronique n'est totalement sécurisé. Si
                                    vous avez des raisons de croire que votre interaction avec nous n'est plus sécurisée, veuillez
                                    nous en informer immédiatement.
                                </p>
                            </div>
                        </div>

                        {/* Vos droits */}
                        <div className="content-block highlight-block">
                            <h2 className="section-title">Vos droits</h2>
                            <div className="text-content">
                                <p>
                                    Conformément aux lois n° 2017-20 et n°2009-09 en vigueur en République du Bénin, vous disposez
                                    des droits suivants concernant vos données personnelles :
                                </p>
                                <ul className="styled-list">
                                    <li><strong>Droit d'accès :</strong> Vous pouvez obtenir la confirmation que des données vous concernant sont
                                        traitées ainsi qu'une copie de ces données</li>
                                    <li><strong>Droit de rectification :</strong> Vous pouvez demander la correction de données inexactes ou
                                        incomplètes vous concernant</li>
                                    <li><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données pour des
                                        motifs légitimes</li>
                                    <li><strong>Droit de suppression :</strong> Vous pouvez demander la suppression de vos données dans certaines
                                        conditions prévues par la loi</li>
                                    <li><strong>Droit de limitation :</strong> Vous pouvez demander la limitation du traitement de vos données
                                        dans certaines situations</li>
                                </ul>
                                <p>
                                    Pour exercer ces droits, vous pouvez nous contacter par email via notre formulaire de contact
                                    ou par courrier à l'adresse indiquée ci-dessous. Nous nous engageons à répondre à votre demande
                                    dans les meilleurs délais et au plus tard dans un délai d'un mois suivant la réception de votre
                                    demande. Une pièce d'identité pourra vous être demandée pour vérifier votre identité.
                                </p>
                            </div>
                        </div>

                        {/* Cookies */}
                        <div className="content-block">
                            <h2 className="section-title">Utilisation des cookies</h2>
                            <div className="text-content">
                                <p>
                                    Notre site utilise des cookies pour améliorer votre expérience de navigation et personnaliser
                                    le contenu. Les cookies sont de petits fichiers texte stockés sur votre appareil qui nous permettent
                                    de reconnaître votre navigateur et de mémoriser certaines informations.
                                </p>
                                <p>
                                    Nous utilisons différents types de cookies : des cookies techniques nécessaires au fonctionnement
                                    du site, des cookies de mesure d'audience pour établir des statistiques de fréquentation, et des
                                    cookies publicitaires pour vous proposer des contenus adaptés à vos centres d'intérêt.
                                </p>
                                <p>
                                    Vous pouvez à tout moment modifier vos préférences en matière de cookies via les paramètres de
                                    votre navigateur. Sachez cependant que le refus de certains cookies peut affecter le bon
                                    fonctionnement du site et limiter l'accès à certaines fonctionnalités.
                                </p>
                            </div>
                        </div>

                        {/* Modifications */}
                        <div className="content-block">
                            <h2 className="section-title">Modifications de la politique</h2>
                            <div className="text-content">
                                <p>
                                    CINEF se réserve le droit de modifier la présente politique de confidentialité à tout moment
                                    pour refléter les changements dans nos pratiques, la législation applicable ou pour d'autres
                                    raisons opérationnelles. Toute modification sera publiée sur cette page avec une date de mise
                                    à jour actualisée.
                                </p>
                                <p>
                                    Nous vous encourageons à consulter régulièrement cette page pour rester informé de la manière
                                    dont nous protégeons vos données. En cas de modification substantielle, nous vous en informerons
                                    par email ou via une notification sur notre site avant que les changements ne prennent effet.
                                </p>
                            </div>
                        </div>

                    </div>
                </section>

                {/* Section contact */}
                <section className="contact-section">
                    <div className="container-policy">
                        <div className="contact-header">
                            <FaEnvelope className="contact-main-icon" />
                            <h2>Des questions sur notre politique ?</h2>
                            <p>Notre équipe est à votre disposition pour répondre à toutes vos questions</p>
                        </div>
                        <div className="contact-grid">
                            <div className="contact-card">
                                <FaMapMarkerAlt className="contact-icon" />
                                <h3>Adresse</h3>
                                <p>Ilot 1398 Ste Rita<br />Immeuble BOCOVE<br />Cotonou, Bénin</p>
                            </div>
                            <div className="contact-card">
                                <FaPhone className="contact-icon" />
                                <h3>Téléphone</h3>
                                <p>+229 63 18 60 60</p>
                            </div>
                            <div className="contact-card">
                                <FaEnvelope className="contact-icon" />
                                <h3>Email</h3>
                                <p>contact@cinef-bj.com</p>
                            </div>
                        </div>
                    </div>
                </section>

                <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .policy-wrapper {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
          color: #2d3748;
          background: #ffffff;
          line-height: 1.7;

        }

        .container-policy {
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header */
        .policy-header {
          background: white;
          border-bottom: 1px solid #e2e8f0;
          padding: 20px 0;
          position: sticky;
          top: 100px;
          z-index: 100;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo-section {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .logo-icon {
          font-size: 32px;
          color: #fd7e14;
        }

        .site-title {
          font-size: 24px;
          font-weight: 700;
          color: #1a202c;
          line-height: 1;
          margin-bottom: 4px;
        }

        .site-subtitle {
          font-size: 13px;
          color: #718096;
          font-weight: 500;
        }

        .catalog-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .catalog-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(253, 126, 20, 0.3);
        }

        /* Modal Catalogue */
        .catalog-modal {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }

        .catalog-content {
          background: white;
          border-radius: 16px;
          padding: 40px;
          max-width: 500px;
          width: 100%;
          position: relative;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .close-btn {
          position: absolute;
          top: 16px;
          right: 16px;
          background: #f7fafc;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          font-size: 24px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #718096;
          transition: all 0.2s;
        }

        .close-btn:hover {
          background: #edf2f7;
          color: #2d3748;
        }

        .catalog-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 16px;
        }

        .catalog-icon {
          font-size: 36px;
          color: #fd7e14;
        }

        .catalog-header h3 {
          font-size: 24px;
          font-weight: 700;
          color: #1a202c;
        }

        .catalog-description {
          color: #4a5568;
          margin-bottom: 28px;
          line-height: 1.6;
        }

        .catalog-actions {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .download-btn,
        .view-btn {
          flex: 1;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          border: none;
          font-family: inherit;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .download-btn {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
        }

        .download-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(253, 126, 20, 0.3);
        }

        .view-btn {
          background: white;
          border: 2px solid #fd7e14;
          color: #fd7e14;
        }

        .view-btn:hover {
          background: #fff5f0;
        }

        /* Hero Section */
        .hero-section {
          padding: 80px 0 60px;
          background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
          text-align: center;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 600;
          color: #198754;
          margin-bottom: 24px;
        }

        .hero-badge svg {
          font-size: 16px;
        }

        .hero-title {
          font-size: 42px;
          font-weight: 800;
          color: #1a202c;
          margin-bottom: 20px;
          letter-spacing: -0.5px;
        }

        .hero-desc {
          font-size: 17px;
          color: #4a5568;
          max-width: 800px;
          margin: 0 auto 24px;
          line-height: 1.7;
        }

        .hero-meta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #718096;
          padding: 8px 16px;
          background: white;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        /* Main Content */
        .main-content {
          padding: 60px 0 80px;
        }

        .content-block {
          margin-bottom: 56px;
        }

        .content-block:last-child {
          margin-bottom: 0;
        }

        .title-with-icon {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 20px;
        }

        .section-icon {
          font-size: 28px;
          color: #fd7e14;
        }

        .section-title {
          font-size: 28px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 20px;
        }

        .text-content {
          font-size: 16px;
          color: #4a5568;
          line-height: 1.8;
        }

        .text-content p {
          margin-bottom: 20px;
          text-align: justify;
        }

        .text-content p:last-child {
          margin-bottom: 0;
        }

        .styled-list {
          margin: 20px 0;
          padding-left: 24px;
        }

        .styled-list li {
          margin-bottom: 12px;
          padding-left: 8px;
          position: relative;
        }

        .styled-list li::marker {
          color: #fd7e14;
        }

        .highlight-block {
          background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
          padding: 40px;
          border-radius: 16px;
          border-left: 4px solid #fd7e14;
        }

        /* Contact Section */
        .contact-section {
          padding: 60px 0;
          background: #fafafa;
        }

        .contact-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .contact-main-icon {
          font-size: 48px;
          color: #fd7e14;
          margin-bottom: 16px;
        }

        .contact-header h2 {
          font-size: 32px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 12px;
        }

        .contact-header p {
          font-size: 16px;
          color: #718096;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .contact-card {
          background: white;
          padding: 32px 24px;
          border-radius: 12px;
          text-align: center;
          border: 1px solid #e2e8f0;
          transition: all 0.3s;
        }

        .contact-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
          border-color: #fd7e14;
        }

        .contact-icon {
          font-size: 32px;
          color: #fd7e14;
          margin-bottom: 16px;
        }

        .contact-card h3 {
          font-size: 18px;
          font-weight: 600;
          color: #1a202c;
          margin-bottom: 8px;
        }

        .contact-card p {
          font-size: 15px;
          color: #718096;
          line-height: 1.6;
        }

        
       

        

        
       
        /* Responsive */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 32px;
          }

          .hero-desc {
            font-size: 16px;
          }

          .section-title {
            font-size: 24px;
          }

          .text-content {
            font-size: 15px;
          }

          .contact-grid {
            grid-template-columns: 1fr;
          }

          .footer-content {
            flex-direction: column;
            gap: 16px;
            text-align: center;
          }

          .highlight-block {
            padding: 24px;
          }

          .catalog-content {
            padding: 24px;
          }

          .catalog-actions {
            flex-direction: column;
          }

          .download-btn,
          .view-btn {
            width: 100%;
          }

          .header-content {
            flex-direction: column;
            gap: 16px;
          }

          .catalog-btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
            </div>
            <Footer />
        </>
    );
};

export default Confidentialite;